import { showArea } from '../helpers';
export var doUndo = function ({ state, ol }) {
  if (state.fillHistoryPointer >= 0 && state.fillOn) {
    state.fillHistoryPointer--;
    if (state.fillFeatures) ol.layers.vector2.removeFeatures([state.fillFeatures]);
    if (state.fillHistoryPointer > -1) {
      state.fillFeatures = state.fillHistory[state.fillHistoryPointer].clone();
      ol.layers.vector2.addFeatures([state.fillFeatures]);
      showArea(state.fillFeatures);
    } else {
      state.fillHistory = [];
      state.fillFeatures = null;
      $('#undo-redo-flood').hide();
      $('#output').html('');
    }
  } else {
    if (ol.controls.polyTitle.handler.line) {
      if (ol.controls.polyTitle.handler.line.geometry.components.length > 3) {
        ol.controls.polyTitle.undo();
      } else {
        ol.controls.polyTitle.cancel();
        ol.controls.polyTitle.deactivate();
        ol.controls.polyTitle.activate();
        $('#undo-redo').hide();
      }
    } else if (ol.controls.addPoly.handler.line) {
      if (ol.controls.addPoly.handler.line.geometry.components.length > 3) {
        ol.controls.addPoly.undo();
      } else {
        ol.controls.addPoly.cancel();
        ol.controls.addPoly.deactivate();
        ol.controls.addPoly.activate();
        $('#undo-redo-other').hide();
      }
    }
    if (state.latestFeaturePos > 0) {
      state.lastEditMode = 'Modifying';
      state.latestFeaturePos--;
      state.annotation.geometry = state.latestFeature[state.latestFeaturePos].clone();
      ol.controls.modifyFeature.unselectFeature(state.annotation);
      ol.layers.vector2.redraw();
      ol.controls.modifyFeature.selectFeature(state.annotation);
      state.lastEditMode = '';
      if (state.latestFeaturePos == 0) {
        $('#undo-redo-other').hide();
        $('#undo-redo').hide();
        state.latestFeature = [state.annotation.geometry.clone()];
      }
    }
  }
};
export var doRedo = function ({ state, ol }) {
  if (state.fillHistoryPointer !== state.fillHistory.length - 1 && state.fillOn) {
    state.fillHistoryPointer++;
    if (state.fillFeatures) ol.layers.vector2.removeFeatures([state.fillFeatures]);
    state.fillFeatures = state.fillHistory[state.fillHistoryPointer].clone();
    ol.layers.vector2.addFeatures([state.fillFeatures]);
    showArea(state.fillFeatures);
  } else {
    if (ol.controls.polyTitle.handler.line && ol.controls.polyTitle.handler.line.geometry.components.length >= 3) {
      try {
        ol.controls.polyTitle.redo();
      } catch (error) {
        //
      }
    } else if (ol.controls.addPoly.handler.line && ol.controls.addPoly.handler.line.geometry.components.length >= 3) {
      try {
        ol.controls.addPoly.redo();
      } catch (error) {
        //
      }
    }
    if (state.latestFeaturePos < state.latestFeature.length - 1) {
      state.lastEditMode = 'Modifying';
      state.latestFeaturePos++;
      state.annotation.geometry = state.latestFeature[state.latestFeaturePos].clone();
      ol.controls.modifyFeature.unselectFeature(state.annotation);
      ol.layers.vector2.redraw();
      ol.controls.modifyFeature.selectFeature(state.annotation);
      state.lastEditMode = '';
    }
  }
};
